<template>
    <v-row>
        <v-col>
            <h1 style="line-height: initial">{{ title }}</h1>
        </v-col>
        <v-col class="d-flex justify-end align-end" v-if="link">
            <!-- link with "already have an account? login" -->
            <TextLink :link="link" />
        </v-col>
    </v-row>
</template>

<script>
import TextLink from "@/components/registration/TextLink.vue";

export default {
    name: "CardTitle",
    components: {
        TextLink,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        link: {
            type: Object,
            required: false,
        },
    },
};
</script>

<style scoped>
h1 {
    text-transform: uppercase;
}
.v-card-title {
    margin-bottom: 1rem;
    font-size: 1.2rem;
    font-weight: 600;
}
</style>
